import type { RentCreditOption } from '../../../helpers/utils/types';

export const scrollToRedeemSection = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  el.classList.add('rd-flash');
  setTimeout(() => el.classList.remove('rd-flash'), 1500);
};

export const formatPoints = (value: number) =>
  new Intl.NumberFormat('en-US').format(Math.max(0, Math.round(value)));

export const formatPointsShort = (value: number) => {
  const n = Math.max(0, Math.round(value));
  if (n >= 1000) return `${Math.round(n / 1000)}k`;
  return String(n);
};

export const findBestValueRentCreditId = (options: RentCreditOption[]): string | null => {
  if (options.length === 0) return null;
  let bestId = options[0].rentCreditOptionId;
  let bestRatio = Number(options[0].points) / Math.max(Number(options[0].amount), 1);

  for (const option of options.slice(1)) {
    const ratio = Number(option.points) / Math.max(Number(option.amount), 1);
    if (ratio < bestRatio) {
      bestRatio = ratio;
      bestId = option.rentCreditOptionId;
    }
  }

  return bestId;
};

export const getCurrentMonthLabel = () =>
  new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
